<style lang="scss" scoped>
.workshopHourOuput::-webkit-scrollbar {
  display: none;
}

.grid {
  &:not(:last-child) {
    margin-right: 10px;
  }
}
</style>

<style lang="scss" scoped>
.weier-prodcution-monitor-border {

  border: 1px solid;
  border-image: url("../../../../../../assets/img/web/weier/production/xiankuang2.png") 10 stretch;
}
</style>

<template>
  <div class="workshopHourOuput weier-prodcution-monitor-border" ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;background:#121212;">
    <video :src="'https://yiplus-2-dev.obs.cn-south-1.myhuaweicloud.com/%E5%85%AC%E5%85%B1%E6%96%87%E4%BB%B6/%E7%BB%B4%E5%B0%94/%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91/%E7%94%9F%E4%BA%A7%E7%AE%A1%E7%90%86%E7%9C%8B%E6%9D%BF_%E7%BB%B4%E5%B0%94%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91.mp4'" autoplay loop muted :controls="false" style="width: 100%;height: 100%;object-fit: cover;"></video>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_customize_weier_monitor_production_video",
  components: {},
  props: {
    datas: {
      type: Object,
      default: () => {
        return {};
      },

    },
  },
  data() {
    return {
    };
  },


  created() {

  },
  activated() {
    this.resize();
  },
  mounted() {
    setTimeout(() => {
      this.resize();
    }, 700);
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {

      }, 800);
    },

  },
};
</script>
